









































import InputCode from "@/common/components/atoms/InputCode.vue";
import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import LocalStorage from "@/general/utils/storage";

@Component({
  components: { InputCode }
})
export default class FormCode extends Vue {
  @Prop({ type: Object, required: false }) code!: any;

  code1 = "";
  code2 = "";
  code3 = "";
  code4 = "";

  keypressed(codeNumber: any) {
    if (codeNumber) {
      (this.$refs[`code${codeNumber}`] as any).selfFocus();
    }
  }
  updateValue(codeNumber: any) {
    const code = this.code1 + this.code2 + this.code3 + this.code4;
    this.$emit("set", code);
  }

  async created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (
      urlParams.get("back_from") &&
      urlParams.get("back_from") == "email_confirmation"
    ) {
      const code = LocalStorage.getItem("code")
        ? (LocalStorage.getItem("code") as string)
        : "";

      const codeArr = code.split("");
      this.code1 = codeArr[0];
      this.code2 = codeArr[1];
      this.code3 = codeArr[2];
      this.code4 = codeArr[3];
      this.$emit("set", code);
    }
  }
}
